import { useEffect } from 'react'

const useScrollTp = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })

    /* disable overscroll/bounce in safari/chrome */
    document.documentElement.style.position = 'static'
    document.documentElement.style.overflow = 'scroll'
  }, [])

  return null
}

export default useScrollTp
